<template>
  <div>

    <v-layout wrap>
      <v-flex xs6 pr-6>
        <v-layout wrap style="width: 100%; position: relative; overflow-y: scroll; height: calc(90vh); background-color: white">
          <v-flex xs12>
            <div style="width: 100%; overflow-y: scroll; height:100%; position: relative;">
              <div v-for="(_, pageIndex) in Array(cvPagesNb).fill(0)" :key="pageIndex">
                <pdf :src="cvPdfUrl" :page="pageIndex + 1"></pdf>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6>
        <v-banner class="banner-without-padding" style="z-index:3;" sticky single-line>
          <v-layout wrap style="position: fixed; z-index: 3; width: 40%; background-color:white; height: 150px;">
            <v-flex xs12>
              
              <v-layout wrap>
                <v-flex xs12 pt-6>
                  <v-layout wrap>
                    <v-flex xs11>
                      <h3>{{ $t('a') }}</h3>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn @click="closeMainDialog" x-small outlined fab color="primary" style="position: absolute; margin-right: 30px; margin-top:-7px">
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 mt-2>
                  <small>
                    <div>{{ $t('b') }}</div>
                    <!-- <div>{{ $t('c') }}</div>
                    <div>
                      <span>{{ $t('d') }}</span>
                      <v-tooltip right dark>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-1 mb-1" color="primary" small v-bind="attrs" v-on="on">mdi-information</v-icon>
                        </template>
                        <small v-html="$t('infoTooltipContent')"/>
                      </v-tooltip>
                    </div> -->
                  </small>
                </v-flex>
              </v-layout>

              <!-- <v-layout wrap mt-1 mb-1>
                <v-flex xs12>
                  <v-tabs v-model="activeTabId" fixed-tabs>
                    <v-tab href="#algo3" >
                      <v-progress-circular v-if="isHrflowParsingPending" class="mr-2" color="primary" indeterminate :size="13" :width="1"/>
                      {{ $t('e') }}
                    </v-tab>
                    <v-tab href="#algo1">
                      {{ $t('g') }}
                    </v-tab>
                    <v-tab href="#deleteAll">
                      {{ $t('h') }}
                    </v-tab>
                  </v-tabs>
                </v-flex>
              </v-layout> -->

            </v-flex>
          </v-layout>
        </v-banner>

        <v-tabs-items v-model="activeTabId" class="whiteBackground" style="margin-top:170px">
          
          <v-tab-item value="algo3">
            <small>
              <v-layout wrap justify-center v-if="isHrflowParsingPending" mt-12>
                <v-flex xs12 text-center mt-12>
                  <div>
                    {{ $t('t') }}
                  </div>
                  <div class="mt-1">
                    {{ $t('u') }}
                  </div>
                </v-flex>
                <v-flex xs6 mt-3>
                  <v-progress-linear indeterminate/>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center v-if="isHrflowError" mt-12>
                <v-flex xs12 text-center mt-12>
                  <div class="orange--text">
                    {{ $t('v') }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="dossier.isHrflowParsingDone">
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 text-end pr-3 mt-2>
                      <v-btn @click="isShowingUseHrflowExperiencesDialog = true" small outlined>{{ $t('w') }}</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 mt-2 mb-1>
                      {{ $t('x') }}
                    </v-flex>
                    <v-flex xs12>
                      <v-divider class="primary"/>
                    </v-flex>
                    <v-flex xs12 v-if="hrflowExperiences">
                      <div style="overflow-y: scroll; height: calc(90vh - 250px); position: relative;">
                        <v-layout wrap v-for="(experience, index) in hrflowExperiences" :key="index" :id="`view-experiences-${index}`">
                          <v-flex xs12>
                            <v-layout wrap>
                              <v-flex xs3 class="leftCell" pl-1>
                                <b>{{ $t('y') }} {{ index + 1 }}</b>
                              </v-flex>
                              <v-flex xs9>
                                <view-experience :experience="experience" />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <v-divider class="primary"/>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap v-if="hrflowExperiences.length === 0">
                          <v-flex xs3>
                          </v-flex>
                          <v-flex xs9 pl-2>
                            <i>{{ $t('z') }}</i>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </small>
          </v-tab-item>

          <v-tab-item value="algo2">
            <small>
              <v-layout wrap justify-center v-if="isAffindaParsingPending" mt-12>
                <v-flex xs12 text-center mt-12>
                  <div>
                    {{ $t('m') }}
                  </div>
                  <div class="mt-1">
                    {{ $t('n') }}
                  </div>
                </v-flex>
                <v-flex xs6 mt-3>
                  <v-progress-linear indeterminate/>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center v-if="isAffindaError" mt-12>
                <v-flex xs12 text-center mt-12>
                  <div class="orange--text">
                    {{ $t('o') }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="dossier.isAffindaParsingDone">
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 text-end pr-3 mt-2>
                      <v-btn @click="isShowingUseAffindaExperiencesDialog = true" small outlined>{{ $t('p') }}</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 mt-2 mb-1>
                      {{ $t('q') }}
                    </v-flex>
                    <v-flex xs12>
                      <v-divider class="primary"/>
                    </v-flex>
                    <v-flex xs12 v-if="affindaExperiences">
                      <div style="overflow-y: scroll; height: calc(90vh - 250px); position: relative;">
                        <v-layout wrap v-for="(experience, index) in affindaExperiences" :key="index" :id="`view-experiences-${index}`">
                          <v-flex xs12>
                            <v-layout wrap>
                              <v-flex xs3 class="leftCell" pl-1>
                                <b>{{ $t('r') }} {{ index + 1 }}</b>
                              </v-flex>
                              <v-flex xs9>
                                <view-experience :experience="experience" />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <v-divider class="primary"/>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap v-if="affindaExperiences.length === 0">
                          <v-flex xs3>
                          </v-flex>
                          <v-flex xs9 pl-2>
                            <i>{{ $t('s') }}</i>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </small>
          </v-tab-item>

          <v-tab-item value="algo1">
            <small>
              <v-layout wrap>
                <v-flex xs12 text-end pr-3>
                  <v-btn @click="isShowingUseOriginalExperiencesDialog = true" small outlined>{{ $t('i') }}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 mt-3 mb-1>
                  {{ $t('j') }}
                </v-flex>
                <v-flex xs12>
                  <v-divider class="primary"/>
                </v-flex>
                <v-flex xs12 v-if="originalExperiences">
                  <div style="overflow-y: scroll; height: calc(85vh - 250px); position: relative;">
                    <v-layout wrap v-for="(experience, index) in originalExperiences" :key="index" :id="`view-experiences-${index}`">
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs3 class="leftCell" pl-1>
                            <b>{{ $t('k') }} {{ index + 1 }}</b>
                          </v-flex>
                          <v-flex xs9>
                            <view-experience :experience="experience" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider class="primary"/>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap v-if="originalExperiences.length === 0">
                      <v-flex xs3>
                      </v-flex>
                      <v-flex xs9 pl-2>
                        <i>{{ $t('l') }}</i>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </small>
          </v-tab-item>

          <v-tab-item value="deleteAll">
            <v-layout wrap pr-6>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs12>
                    <small>
                      <div class="mt-3">{{ $t('deleteAllExperiences2') }}</div>
                      <div><b>{{ $t('deleteAllExperiences2bis') }}</b></div>
                      <div class="text-center mt-4 mb-5 mr-2">
                        <span @click="isShowingVideoDialog = true" style="cursor:hand">
                          <v-icon small style="padding-bottom: 2px">mdi-play-circle</v-icon>
                          <span class="ml-2 textAsLink">{{ $t('video0') }}</span>
                        </span>
                      </div>
                      <ul>
                        <li>{{ $t('deleteAllExperiences3') }}</li>
                        <li>{{ $t('deleteAllExperiences4') }}
                          <ul>
                            <li>{{ $t('deleteAllExperiences5') }}</li>
                            <li>{{ $t('deleteAllExperiences6') }}</li>
                            <li><b>{{ $t('deleteAllExperiences6bis') }}</b></li>
                            <li>{{ $t('deleteAllExperiences7') }}</li>
                          </ul>
                        </li>
                      </ul>
                    </small>
                  </v-flex>
                </v-layout>
                <v-layout wrap mt-6>
                  <v-flex xs12 text-center>
                    <v-btn small @click="isShowingDeleteAllExperiencesDialog = true" outlined>{{ $t('deleteAllExperiences8') }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isShowingVideoDialog" height="90%" width="70%">
      <v-card class="pa-2 text-center" v-if="isShowingVideoDialog">
        <h3 class="mb-2 mt-2">{{ $t('video1') }}</h3>
        <video
          controls
          loop
          autoplay
          width="100%"
          height="600px"
          src="https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FRecommencer%20les%20expe%CC%81riences.mov?alt=media&token=3865561d-88a1-4fc7-942e-7d256b633928"
        />
      </v-card>
    </v-dialog>


    <v-dialog v-model="isShowingUseOriginalExperiencesDialog"  width="40%">
      <v-card class="pa-6 text-center">
        <h3 class="mb-2">{{ $t('1') }}</h3>
        <small>
          {{ $t('2') }}
        </small>
        <v-layout wrap mt-4>
          <v-flex xs6 text-center>
            <v-btn small @click="useOriginalExperiences" class="primary">{{ $t('3') }}</v-btn>
          </v-flex>
          <v-flex xs6 text-center>
            <v-btn small @click="isShowingUseOriginalExperiencesDialog = false" outlined>{{ $t('4') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingUseAffindaExperiencesDialog"  width="40%">
      <v-card class="pa-6 text-center">
        <h3 class="mb-2">{{ $t('5') }}</h3>
        <small>
          {{ $t('6') }}
        </small>
        <v-layout wrap mt-4>
          <v-flex xs6 text-center>
            <v-btn small @click="useAffindaExperiences" class="primary">{{ $t('7') }}</v-btn>
          </v-flex>
          <v-flex xs6 text-center>
            <v-btn small @click="isShowingUseAffindaExperiencesDialog = false" outlined>{{ $t('8') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingUseHrflowExperiencesDialog"  width="40%">
      <v-card class="pa-6 text-center">
        <h3 class="mb-2">{{ $t('9') }}</h3>
        <small>
          {{ $t('10') }}
        </small>
        <v-layout wrap mt-4>
          <v-flex xs6 text-center>
            <v-btn small @click="useHrflowExperiences" class="primary">{{ $t('11') }}</v-btn>
          </v-flex>
          <v-flex xs6 text-center>
            <v-btn small @click="isShowingUseHrflowExperiencesDialog = false" outlined>{{ $t('12') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>


    <v-dialog v-model="isShowingDeleteAllExperiencesDialog"  width="40%">
      <v-card class="pa-6 text-center">
        <h3 class="mb-2">{{ $t('13') }}</h3>
        <small>
          {{ $t('14') }}
        </small>
        <v-layout wrap mt-4>
          <v-flex xs6 text-center>
            <v-btn small @click="deleteAllExperiences" class="primary">{{ $t('15') }}</v-btn>
          </v-flex>
          <v-flex xs6 text-center>
            <v-btn small @click="isShowingDeleteAllExperiencesDialog = false" outlined>{{ $t('16') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import axios from 'axios'
import ViewExperience from '@/components/profile/ViewExperience'

export default {
  components: {
    pdf,
    ViewExperience
  },
  props: {
    dossier: Object,
    cvPdfUrl: String,
    cvPagesNb: Number
  },
  data: () => ({
    isShowingVideoDialog: false,
    activeTabId: 'deleteAll',
    isShowingUseOriginalExperiencesDialog: false,
    isShowingUseAffindaExperiencesDialog: false,
    isShowingUseHrflowExperiencesDialog: false,
    isShowingDeleteAllExperiencesDialog: false,
    originalExperiences: null,
    affindaExperiences: null,
    hrflowExperiences: null,
    isAffindaParsingPending: false,
    isAffindaError: false,
    isHrflowParsingPending: false,
    isHrflowError: false
  }),
  mounted() {
    console.log('Launching alternative parsers'); // eslint-disable-line
    // this.getOriginalExperiences()
    // this.getAffindaExperiences()
    // this.getHrflowExperiences()
  },
  methods: {
    async getOriginalExperiences() {
      const fileRef = this.$storage.ref(`companies/${this.dossier.companyId}/users/${this.dossier.userId}/dossiers/${this.dossier.id}/formattedTextkernelProfile.json`);
      const url = await fileRef.getDownloadURL()
      this.originalExperiences = (await axios.get(url)).data.experiences.map(xp => {
        xp.description = this.decreaseIndents(xp.description)
        return xp
      }) 
    },
    async getAffindaExperiences() {
      if (!this.dossier.isAffindaParsingDone && !this.isAffindaParsingPending) {
        this.isAffindaParsingPending = true
        // Call server to trigger affinda parsing
        const { success } = (await this.$functions.httpsCallable('parseCvWithAffinda')({ dossierId: this.dossier.id })).data
        if (!success) {
          this.isAffindaError = true;
          this.isAffindaParsingPending = false;
          return;
        }
        this.dossier.isAffindaParsingDone = true;
        this.isAffindaParsingPending = false;
      }
      // Fetch Affinda parsing from storage
      const fileRef = this.$storage.ref(`companies/${this.dossier.companyId}/users/${this.dossier.userId}/dossiers/${this.dossier.id}/formattedAffindaProfile.json`);
      const url = await fileRef.getDownloadURL()
      this.affindaExperiences = (await axios.get(url)).data.experiences.map(xp => {
        xp.description = this.decreaseIndents(xp.description)
        return xp
      })
      this.isAffindaParsingPending = false
    },
    async getHrflowExperiences() {
      if (!this.dossier.isHrflowParsingDone && !this.isHrflowParsingPending) {
        this.isHrflowParsingPending = true
        // Call server to trigger Hrflow parsing
        const { success } = (await this.$functions.httpsCallable('parseCvWithHrflow')({ dossierId: this.dossier.id })).data
        if (!success) {
          this.isHrflowError = true;
          this.isHrflowParsingPending = false;
          return;
        }
        this.dossier.isHrflowParsingDone = true;
        this.isHrflowParsingPending = false;
      }
      // Fetch Hrflow parsing from storage
      const fileRef = this.$storage.ref(`companies/${this.dossier.companyId}/users/${this.dossier.userId}/dossiers/${this.dossier.id}/formattedHrflowProfile.json`);
      const url = await fileRef.getDownloadURL()
      this.hrflowExperiences = (await axios.get(url)).data.experiences.map(xp => {
        xp.description = this.decreaseIndents(xp.description)
        return xp
      })
      this.isHrflowParsingPending = false
    },
    closeMainDialog() {
      this.$emit('setIsShowingStartOverDialog', { isShowingStartOverDialog: false })
    },
    deleteAllExperiences() {
      this.dossier.profile.experiences = []
      this.updateDossierStartOverExperiencesParserUsed('deleteAll')
      this.closeMainDialog()
    },
    useOriginalExperiences() {
      this.dossier.profile.experiences = this.originalExperiences
      this.updateDossierStartOverExperiencesParserUsed('textkernel')
      this.closeMainDialog()
    },
    useAffindaExperiences() {
      this.dossier.profile.experiences = this.affindaExperiences
      this.updateDossierStartOverExperiencesParserUsed('affinda')
      this.closeMainDialog()
    },
    useHrflowExperiences() {
      this.dossier.profile.experiences = this.hrflowExperiences
      this.updateDossierStartOverExperiencesParserUsed('hrflow')
      this.closeMainDialog()
    },
    updateDossierStartOverExperiencesParserUsed(parserName) {
      this.$functions.httpsCallable('updateDossierStartOverExperiencesParserUsed')({
        dossierId: this.dossier.id,
        startOverExperiencesParserUsed: parserName
      })
    },
    decreaseIndents(quillStr) {
      quillStr = quillStr.replace(/(<li class="ql-indent-)\d(">)/g, function(match) {
        const startTag = '<li class="ql-indent-'
        const endTag = '">'
        const newIndent = parseInt(match.replace(startTag, '').replace(endTag, '')) - 1
        return `${startTag}${newIndent}${endTag}`;
      });
      return quillStr
    },
  }
}
</script>


<i18n>
{
  "fr": {
    "deleteAllExperiences2": "Vous pouvez supprimer toutes les expériences et les ré-extraire manuellement une par une.",
    "deleteAllExperiences2bis": "Pour chaque expérience, utilisez notre outil vous permettant de l'extraire d'un seul coup depuis le CV original.",
    "deleteAllExperiences3": "Les expériences existantes seront toutes supprimées.",
    "deleteAllExperiences4": "Puis pour chaque expérience :",
    "deleteAllExperiences5": "Cliquez sur \"Ajouter\".",
    "deleteAllExperiences6": "Cliquez sur la nouvelle expérience vide pour l'éditer.",
    "deleteAllExperiences6bis": "Cliquez sur \"Extraire toute l'expérience d'un seul coup\".",
    "deleteAllExperiences7": "Copiez-collez tout le texte de l'expérience du CV original et cliquez sur \"Extraire\".",
    "deleteAllExperiences8": "Supprimer toutes les expériences",
    "deleteAllExperiences9": "Annuler",

    "video0": "Voir un exemple",
    "video1": "Comment extraire manuellement chaque expérience avec notre outil",

    "infoTooltipContent": "<div>L'algorithme 1 est celui qui apporte les meilleurs résultats dans la majorité des cas.</div><div>C'est celui utilisé par défaut.</div><br><div>L'algorithme 2 est spécialisé sur les CVs qui sont géométriquement plus compliqués.</div><div>Utile quand les expériences professionnelles sont organisées en colonnes ou en tableau.</div><div>Inconvénient : vous devrez ajuster les retours à la ligne et le niveau d'indentation des bulletpoints.</div>",

    "a": "Échec de l'extraction des expériences ?",
    "b": "Les expériences professionnelles sont parfois difficiles à extraire automatiquement.",
    "c": "Nous mettons à votre disposition le résultat de 2 algorithmes.",
    "d": "Choisissez celui qui a le mieux fonctionné.",
    "e": "Algo 2",
    "f": "Algo 2",
    "g": "Algo 1",
    "h": "Manuellement",
    "i": "Utiliser les expériences de l'algorithme 1",
    "j": "Expériences professionnelles extraites avec l'algorithme 1 :",
    "k": "Expérience",
    "l": "Aucune expérience.",
    "m": "Extraction en cours des expériences avec l'Algorithme 2.",
    "n": "Merci de patienter environ 30 secondes.",
    "o": "Erreur lors de l'extraction des expériences avec l'algorithme 2.",
    "p": "Utiliser les expériences de l'algorithme 2",
    "q": "Expériences professionnelles extraites avec l'algorithme 2 :",
    "r": "Expérience",
    "s": "Aucune expérience.",
    "t": "Extraction en cours des expériences avec l'Algorithme 2.",
    "u": "Merci de patienter environ 30 secondes.",
    "v": "Erreur lors de l'extraction des expériences avec l'algorithme 2.",
    "w": "Utiliser les expériences de l'algorithme 2",
    "x": "Expériences professionnelles extraites avec l'algorithme 2 :",
    "y": "Expérience",
    "z": "Aucune expérience.",
    "1": "Remplacer les expériences professionnelles par celles de l'algorithme 1 ?",
    "2": "Attention, les données des expériences seront écrasées et les modifications que vous avez éventuellement faites seront perdues.",
    "3": "Remplacer les expériences",
    "4": "Annuler",
    "5": "Remplacer les expériences professionnelles par celles de l'algorithme 2 ?",
    "6": "Attention, les données des expériences seront écrasées et les modifications que vous avez éventuellement faites seront perdues.",
    "7": "Remplacer les expériences",
    "8": "Annuler",
    "9": "Remplacer les expériences professionnelles par celles de l'algorithme 2 ?",
    "10": "Attention, les données des expériences seront écrasées et les modifications que vous avez éventuellement faites seront perdues.",
    "11": "Remplacer les expériences",
    "12": "Annuler",
    "13": "Supprimer toutes les expériences professionnelles ?",
    "14": "Attention, les données des expériences seront supprimées et les modifications que vous avez éventuellement faites seront perdues.",
    "15": "Supprimer les expériences",
    "16": "Annuler"
  },
  "en": {
    "deleteAllExperiences2": "You can delete all the experiences and manually re-extract them one by one..",
    "deleteAllExperiences2bis": "For each experience, use our tool to extract it at once from the original CV.",
    "deleteAllExperiences3": "The existing experiences will be deleted.",
    "deleteAllExperiences4": "Then, for each experience:",
    "deleteAllExperiences5": "Click on \"Add\".",
    "deleteAllExperiences6": "Click on the new empty experience to edit it.",
    "deleteAllExperiences6bis": "Click on \"Extract the entire experience at once\".",
    "deleteAllExperiences7": "Copy-paste the experience text from the original CV and click on \"Extract\".",
    "deleteAllExperiences8": "Delete all the experiences",
    "deleteAllExperiences9": "Cancel",

    "video0": "See an example",
    "video1": "How to extract manually each experience with our tool",

    "infoTooltipContent": "<div>The algorithm 1 is the one offering best results in most cases.</div><div>It is the one used by default.</div><br><div>The algorithm 2 is specialized on CVs which are geometrically more complicated.</div><div>Useful when the professional experiences are organised in columns or tables.</div><div>Drawback: you will need to adjust the line breaks and the indentation level of the bulletpoints.</div>",

    "a": "Failed at extracting the experiences ?",
    "b": "The professional experiences are sometimes difficult to extract automatically.",
    "c": "We thus offer you the results of multiple algorithms.",
    "d": "Choose the one which worked out the best.",
    "e": "Algo 2",
    "f": "Algo 2",
    "g": "Algo 1",
    "h": "Manually",
    "i": "Use the experiences of the algorithm 1",
    "j": "Professional experiences extracted with the algorithm 1 :",
    "k": "Experience",
    "l": "No experience.",
    "m": "Experiences are being extracted with the algorithm 2.",
    "n": "Please wait for about 30 seconds.",
    "o": "Error while extracting the experiences with the algorithm 2.",
    "p": "Use the experiences of the algorithm 2",
    "q": "Professional experiences extracted with the algorithm 2 :",
    "r": "Experience",
    "s": "No experience.",
    "t": "Experiences are being extracted with the algorithm 2.",
    "u": "Please wait for about 30 seconds.",
    "v": "Error while extracting the experiences with the algorithm 2.",
    "w": "Use the experiences of the algorithm 2",
    "x": "Professional experiences extracted with the algorithm 2 :",
    "y": "Experience",
    "z": "No experience.",
    "1": "Replace the professional experiences with the ones of the algorithm 1 ?",
    "2": "Beware, the data of the current experiences will be overwritten and the modifications that you may have done will be lost.",
    "3": "Replace the experiences",
    "4": "Cancel",
    "5": "Replace the professional experiences with the ones of the algorithm 2 ?",
    "6": "Beware, the data of the current experiences will be overwritten and the modifications that you may have done will be lost.",
    "7": "Replace the experiences",
    "8": "Cancel",
    "9": "Replace the professional experiences with the ones of the algorithm 2 ?",
    "10": "Beware, the data of the current experiences will be overwritten and the modifications that you may have done will be lost.",
    "11": "Replace the experiences",
    "12": "Cancel",
    "13": "Delete all the professional experiences ?",
    "14": "Beware, the data of the current experiences will be deleted and the modifications that you may have done will be lost.",
    "15": "Delete all the experiences",
    "16": "Cancel"
  }
}
</i18n>